"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSPECTOR_AGENCIES = exports.INSPECTOR_OTP_MAX_ATTEMPTS = exports.INSPECTOR_OTP_TTL_MINUTES = exports.INSPECTOR_MAX_SESSION_HOURS = exports.DOCUMENT_EXPORT_TTL_DAYS = exports.DOCUMENT_EXPORT_MAX_BYTES = exports.DOCUMENT_EXPORT_MAX_FILES = void 0;
// ── limits ────────────────────────────────────────────────────────────────
exports.DOCUMENT_EXPORT_MAX_FILES = 500;
exports.DOCUMENT_EXPORT_MAX_BYTES = 1024 * 1024 * 1024; // 1 GiB
/** ZIPs (and their emailed link) are kept 7 days. */
exports.DOCUMENT_EXPORT_TTL_DAYS = 7;
/** Longest inspector visit an owner can approve. */
exports.INSPECTOR_MAX_SESSION_HOURS = 24;
exports.INSPECTOR_OTP_TTL_MINUTES = 10;
exports.INSPECTOR_OTP_MAX_ATTEMPTS = 5;
exports.INSPECTOR_AGENCIES = ['ABC', 'IRS', 'Tobacco', 'Health', 'Other'];
//# sourceMappingURL=tenantDocumentsShare.js.map